import {map} from 'rxjs/operators';
import {contractIncrementalOrders$} from '@/orders-contract/orders-contract';
import type {ws} from '@/types';
type ContractOrderRaw = ws.ContractOrderRaw;

const normalOrderStatus2Audio = {
  New: 'orderSubmitted',
  PartiallyFilled: 'orderFilled',
  Filled: 'orderFilled',
  Canceled: 'orderCanceled',
};

const conditionalOrderStatus2Audio = {
  Untriggered: 'orderSubmitted',
  New: 'orderTriggered',
  PartiallyFilled: 'orderFilled',
  Filled: 'orderFilled',
  Deactivated: 'orderCanceled',
  Canceled: 'orderCanceled',
};
const incrementalOrder$ = contractIncrementalOrders$.pipe(map(({orders: {open, closed}}) => [...closed, ...open]));
export const audios$ = incrementalOrder$.pipe(map((orders) => orders.map(convertAudio).filter(Boolean)));

function convertAudio(raw: ContractOrderRaw): string {
  // 先决条件
  const acceptable = ['New', 'Replace', 'Cancel'].indexOf(raw.action) > -1;
  if (!acceptable) {
    return '';
  }

  const isNormal = ['Market', 'Limit'].indexOf(raw.ordType) > -1;
  if (isNormal) {
    return normalOrderStatus2Audio[raw.ordStatus];
  }
  const isConditional = ['Stop', 'StopLimit', 'LimitIfTouched', 'MarketIfTouched'].indexOf(raw.ordType) > -1;
  if (isConditional) {
    return conditionalOrderStatus2Audio[raw.ordStatus];
  }
  return '';
}
